define('views/modules/member/member/edit/member-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/events/user-events',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/parts/tree/tree-view',
    'views/parts/menu/menu-dropdown',
    'views/parts/alert/alert-list',
    'views/modules/profile/edit/account-settings-edit-form',
    'views/modules/member/member/member-lists-controller',
    'views/modules/member/group-panel',
    // templates
    'text!templates/modules/profile/edit/profile-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    UserEvents,
    // views
    VForm,
    VMenuSaveAction,
    VTreeView,
    VMenuDropdown,
    VAlertList,
    VAccountSettingsEditForm,
    VMemberListsController,
    VGroupPanel,
    // templates
    TPersonalInfoEditContent
) {

    var VPersonalInfoEditContent = VForm.extend({
        template: TPersonalInfoEditContent,

        regions: {
            root: "#profile-edit-content",
            menu: ".menu-actions",
            alert: ".alert-list",
            groups: "#group-menu",
            forms: {
                settings: ".account-settings-edit-form",
            },
        },

        initialize: function(options) {
            this.selectedGroup = options.selectedGroup;

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.collection
            });

            this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    radio: false,
                    saveText: 'supervisor:member-edit-save-button',
                    tooltip: { container: this.regions.root, }
                }),
                forms: {
                  settings: new VAccountSettingsEditForm({
                    model: this.model,
                    selectedGroup: this.selectedGroup,
                    collection: this.collection,
                  }),
                },
                alert: new VAlertList({
                    collection: new Backbone.Collection([])
                })
            };

            this.listenTo(this.model, { 'change': this.onModelChange })
                .listenTo(UserEvents, { 'group:manage': this.onDisplayGroupManager });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.forms.settings, zone.forms.$settings);

            return this;
        },

        ////////////
        // events //
        ////////////
        onDisplayGroupManager: function() {
            var grpPanel = new VGroupPanel();
            this.trigger('panel:stack', grpPanel);
        },

        onGroupCollectionUpdate: function() {
            if (!this.selectedGroup) {
                this.onSelectGroup(this.collection.at(0));
            } else {
                this.onSelectGroup(this.selectedGroup);
            }
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup;
            if (groupModel !== undefined && selectedGroup !== groupModel) {
                if (selectedGroup) {
                    selectedGroup.set('_menuActive', false);
                }

                this.selectedGroup = selectedGroup = groupModel;
            }

            this.view.groups.setLabel(selectedGroup.get('name'));
            this.model.setGroup(groupModel);
            selectedGroup.set('_menuActive', true);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            var phoneNbr = this.view.forms.settings.view.form.phone.getValue();
            var calorie_goal = this.view.forms.settings.view.form.calorie_goal.getValue();

            var rgx = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?[\-\.\ \\\/]?(\d+))?$/g;
            var regex_calorie_goal = /^[\s\d]*$/;

            if (regex_calorie_goal.test(calorie_goal)) {
              if (rgx.test(phoneNbr) || _.isEmpty(phoneNbr)) {
                  this.submit();
              } else {
                this.view.alert.reset();
                this.view.alert.addError("Invalid phone number.");
              }
            } else {
              this.view.alert.reset();
              this.view.alert.addError("Invalid calorie goal.");
            }
        },

        onSuccess: function() {
            this.trigger('member:edit', this.model);
            UserEvents.profileUpdate(this.model);
            this.trigger('back');
        },

        onError: function(response) {
            if (response && response.responseJSON) {
              var errorCode = response.responseJSON.code,
                  message = response.responseJSON.message;

              if (errorCode) {
                this.view.alert.reset();
                this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
              }
            }

        },

        onSubmit: function() {
            var model = this.model;
        },

    });

    return VPersonalInfoEditContent;
});

